import React, { useEffect, useState } from 'react';
import { translate } from '../../i18n';
import { IPaymentProps } from '../../type/paymentProps';
import useBgColorStore from '../../store/bgColor';
import Loader from '../../assets/loader/Loader';
import { IPaymentBreakUp } from '../../type/PaymentBreakup';
import { usePaymentBreakDetails } from '../../hooks/apiHook/operationDetails';

const PaymentBreakup: React.FC<IPaymentProps> = ({
  title,
  operationDate,
  ownerId,
  showHeading,
}) => {
  const { bgColor, updateBgColor } = useBgColorStore();
  const [loading, setLoading] = useState(false);
  const [paymentBreakup, setPaymentBreakup] = useState<IPaymentBreakUp | null>(
    null,
  );

  const {
    data: paymentData,
    isLoading: isPaymentLoading,
    isFetching: isFetching,
    refetch: refetchPayment,
  } = usePaymentBreakDetails(operationDate, ownerId);

  useEffect(() => {
    if (paymentData) {
      setPaymentBreakup(paymentData);
    }
  }, [paymentData]);

  return (
    <div className={`${bgColor} rounded-sm  p-4 w-full`}>
      {showHeading ? (
        <>
          <h3 className="font-semibold text-base text-textColor mb-2 text-start">
            Payment Breakup
          </h3>
        </>
      ) : null}

      {isPaymentLoading || isFetching ? (
        <div className='flex justify-center align-middle'>
        <Loader />
        </div>
        
      ) : (
        <>
          <div className="border-b border-b-customBorder-black mb-4 text-textColorGray text-sm text-start">
            <span>{paymentBreakup?.description}</span>
          </div>

          <div className="flex justify-between">
            <div>
              <p className="text-textColorGray text-sm text-start">
                {translate('paymentBreakup.pax')}
              </p>
              <p className="font-semibold text-base text-start text-textColorGray">
                {paymentBreakup?.pobPax}
              </p>
            </div>

            <div>
              <p className="text-textColorGray text-sm text-start">
                {translate('paymentBreakup.total')}
              </p>
              <p className="font-semibold  text-base text-start text-textColorGray">
                {paymentBreakup?.pobTotal}
              </p>
            </div>

            <div>
              <p className="text-textColorGray text-sm text-start">
                {translate('paymentBreakup.count')}
              </p>
              <p className="font-semibold text-textColorGray text-base text-start">
                {paymentBreakup?.bookNo}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentBreakup;
